/* CAMISETAS de DJs — interacción de tarjetas (espalda -> frontal)
   Desktop: hover (CSS). Móvil: mantener pulsado (~220 ms) muestra el frontal;
   soltar vuelve a la espalda. Un toque corto sigue abriendo el producto. */
(function () {
  'use strict';
  var HOLD_MS = 220;
  var HINT_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12a8 8 0 1 1-2.34-5.66" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M20 4v5h-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setup(card) {
    if (card.dataset.djsFlip) return;
    var media = card.querySelector('.media--hover-effect');
    if (!media || media.querySelectorAll('img').length < 2) return;
    card.dataset.djsFlip = '1';

    var hint = document.createElement('span');
    hint.className = 'djs-flip-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML = HINT_SVG + '<span>Mantén pulsado</span>';
    // .card__media ya es position:absolute en Dawn: sirve de contenedor sin tocar su layout
    media.parentElement.appendChild(hint);

    var timer = null;
    var held = false;

    function start(e) {
      if (e.pointerType === 'mouse') return;
      held = false;
      clearTimeout(timer);
      timer = setTimeout(function () {
        held = true;
        card.classList.add('is-flipped');
      }, HOLD_MS);
    }
    function end() {
      clearTimeout(timer);
      timer = null;
      card.classList.remove('is-flipped');
    }

    card.addEventListener('pointerdown', start, { passive: true });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      card.addEventListener(ev, end, { passive: true });
    });
    card.addEventListener('touchmove', end, { passive: true });
    card.addEventListener(
      'click',
      function (e) {
        if (held) {
          e.preventDefault();
          e.stopPropagation();
          held = false;
        }
      },
      true
    );
    card.addEventListener('contextmenu', function (e) {
      if (held || timer) e.preventDefault();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(setup);
  }

  var scheduled = false;
  function scheduleInit() {
    if (scheduled) return;
    scheduled = true;
    (window.requestIdleCallback || window.setTimeout)(function () {
      scheduled = false;
      init(document);
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // Al volver atrás (bfcache) el navegador restaura el estado anterior: quitamos cualquier
  // tarjeta que quedara volteada y el foco del enlace pulsado para que el hover vuelva a funcionar.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.card-wrapper.is-flipped').forEach(function (c) { c.classList.remove('is-flipped'); });
    var a = document.activeElement;
    if (a && a !== document.body && a.closest && a.closest('.card-wrapper')) a.blur();
  });
  new MutationObserver(scheduleInit).observe(document.documentElement, { childList: true, subtree: true });
})();
